export default {
    A2T_SLACK_CHANNEL: 'https://tiny.amazon.com/gdel2m9i/a2t-slack',
    APG: 'https://apg-library.amazonaws.com/',
    APG_MRA: 'https://apg-library.amazonaws.com/content/542671a6-ea80-4ff6-bb8b-971d894b5f7c',
    APG_MRA_FAQ: 'https://apg-library.amazonaws.com/content/542671a6-ea80-4ff6-bb8b-971d894b5f7c#faq',
    APG_MRA_TROUBLESHOOTING: 'https://apg-library.amazonaws.com/content/542671a6-ea80-4ff6-bb8b-971d894b5f7c#troubleshooting',
    MPA: 'https://mpa.accelerate.amazonaws.com/',
};
